import React from 'react'

class GoogleTagManager extends React.Component {
  
    render() {
        return (<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-P4SHV2Z" height="0" width="0" style={{display:'none',visibility:'hidden'}}></iframe></noscript>)
      } 
  }
  
  export default GoogleTagManager;